import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState('NGN');
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('CurrencyContext initialized with currency:', currency);
  }, [currency]);

  // Static conversion rate (1 USD = 1600 NGN, approximate for 2025)
  const conversionRates = {
    USD: 1,
    NGN: 1600,
  };

  const formatPrice = (price, targetCurrency = currency) => {
    try {
      if (price === undefined || price === null) {
        console.warn('formatPrice: Invalid price', price);
        return '';
      }
  
      const baseCurrency = 'NGN'; // assume all prices come in NGN
      const baseRate = conversionRates[baseCurrency] || 1;
      const targetRate = conversionRates[targetCurrency] || 1;
  
      // Convert NGN price to USD by dividing by NGN rate
      const priceInUSD = price / baseRate;
  
      // Convert from USD to target currency
      const convertedPrice = (priceInUSD * targetRate).toFixed(2);
  
      return targetCurrency === 'NGN'
        ? `₦${parseFloat(convertedPrice).toLocaleString('en-NG')}`
        : `$${parseFloat(convertedPrice).toLocaleString('en-US')}`;
    } catch (err) {
      console.error('formatPrice error:', err);
      setError('Error formatting price');
      return '';
    }
  };
  

  const toggleCurrency = () => {
    try {
      const newCurrency = currency === 'USD' ? 'NGN' : 'USD';
      setCurrency(newCurrency);
      console.log('Currency toggled to:', newCurrency);
    } catch (err) {
      console.error('toggleCurrency error:', err);
      setError('Error toggling currency');
    }
  };

  if (error) {
    console.error('CurrencyContext error:', error);
  }

  return (
    <CurrencyContext.Provider value={{ currency, toggleCurrency, formatPrice, error }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context) {
    console.error('useCurrency: CurrencyContext is undefined');
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
}